export default __webpack_public_path__ + "static/media/screen4.729dee4d.png";